export default "__VITE_ASSET__BlYWjEHL__"